/* @flow */

import { type Endereco } from '../../enderecos/types';
import getInputPorId from '../../utils/get-input-por-id';
import getSelectPorId from '../../utils/get-select-por-id';

const preencherFormEndereco = (endereco: Endereco) => {
    if (endereco.nome === 'RETIRADA NO LOCAL') {
        getInputPorId('retiradaLocal-sim').checked = true;
    }
    getInputPorId('endereco-id').value = String(endereco.id);
    getInputPorId('cep-endereco').value = String(endereco.cep);
    getInputPorId('logradouro-endereco').value = String(endereco.logradouro);
    getInputPorId('numero-endereco').value = String(endereco.numero);
    getInputPorId('bairro-endereco').value = endereco.bairro;
    getInputPorId('cidade-endereco').value = endereco.cidade;
    getSelectPorId('estado-endereco').value = endereco.estado;
    getInputPorId('complemento-endereco').value = endereco.complemento || '';
    getInputPorId('ponto-referencia-endereco').value = endereco.pontoReferencia || '';
};

export default preencherFormEndereco;
